module.exports = __webpack_public_path__ + "img/Marty.bce84ed9.jpg";